import React, { useEffect, useRef, useState } from "react"
import {Text, TextInput, StyleSheet, TouchableOpacity, View, FlatList} from "react-native"
import { IconButton, Modal, Provider as PaperProvider, Portal } from "react-native-paper"

const darkColour = '#2a2d3e'
interface Appear {
  appearUp : boolean
  onError?: boolean;
  pressed?: ()=> void;
  dateReset?: boolean;
  _day?: string;
  _month?: string;
  _year?: string;
  onNewDateSelected: (day:string, month:string, year:string) => void;
}
const DatePicker: React.FC<Appear> = ({appearUp, onError= false, dateReset = true, pressed, _day, _month, _year, onNewDateSelected})=>{
  const [colourDay, setColourDay] = useState('transparent')
  const [colourDayText, setColourDayText] = useState('white')
  const [colourMonth, setColourMonth] = useState('transparent')
  const [colourMonthText, setColourMonthText] = useState('white')
  const [colourYear, setColourYear] = useState('transparent')
  const [colourYearText, setColourYearText] = useState('white')
  const initMonth = new Date().getMonth() + 1
  const initDay = new Date().getDate()
  const [month, setMonth] = useState( _month ? _month : initMonth < 10 ? '0' + initMonth : initMonth.toString());
  const [day, setDay] = useState(_day ? _day : initDay < 10 ? '0' + initDay : initDay.toString());
  const [year, setYear] = useState(_year ? _year : new Date().getFullYear().toString());
  const [dayWidth, setDayWidth] = useState(day.length < 1 ? 25 : 20)
  const [monthWidth, setMonthWidth] = useState(month.length < 1 ? 33 : 20)
  const inputRef1 = useRef<TextInput>(null)
  const inputRef2 = useRef<TextInput>(null)
  const inputRef3 = useRef<TextInput>(null)
  const dateString = month + '/' + day + '/' + year;
  const date = new Date(month + '/' + day + '/' + year);
  const currentMonth = date.getMonth(); 
  const currentYearValue = date.getFullYear();
  const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' } as Intl.DateTimeFormatOptions;
  const isLeapYear = (year: number) => {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  };
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [currentMonthIndex, setCurrentMonthIndex] = useState(new Date().getMonth());
  const scrollIndex = Math.floor((currentYear - 1900) / 4)
  const [canFocus, setCanFocus] = useState (true)
  const [focusNum, setFocusNum] = useState (0)
  const flatListRef = useRef<FlatList>(null);

  interface Month {
    name: string;
    days: number;
    monthNumber: string;
  }

useEffect(() => {
  onNewDateSelected(day, month, year);
}, [day, month, year]);

useEffect(() => {
 setDay('');
 setMonth('')
 setYear('');
}, [dateReset]);

useEffect(() => {
 setDay(_day ? _day : (prev) => prev);
 setMonth(_month ? _month.toString() : (prev) => prev)
 setYear(_year ? _year.toString() : (prev) => prev);
 console.log()
}, [_day, _month, _year]);

useEffect(() => {
  if (canFocus && focusNum === 1 && inputRef1.current) {
    inputRef1.current.focus();
  } else if (canFocus && focusNum === 2 && inputRef2.current) {
    inputRef2.current.focus();
  } else if (canFocus && focusNum === 3 && inputRef3.current) {
    inputRef3.current.focus();
  }
}, [canFocus]);
  const years: number[] = Array.from({ length: 200 }, (_, index) => index + 1900);
    
  const months: Month[] = [
    { name: 'January', days: 31, monthNumber: '01'},
    { name: 'February', days: (currentYear % 4 === 0 && currentYear % 100 !== 0) || (currentYear % 400 === 0) ? 29 : 28, monthNumber: '02' },
    { name: 'March', days: 31, monthNumber: '03' },
    { name: 'April', days: 30, monthNumber: '04' },
    { name: 'May', days: 31, monthNumber: '05' },
    { name: 'June', days: 30, monthNumber: '06' },
    { name: 'July', days: 31, monthNumber: '07' },
    { name: 'August', days: 31, monthNumber: '08' },
    { name: 'September', days: 30, monthNumber: '09' },
    { name: 'October', days: 31, monthNumber: '10' },
    { name: 'November', days: 30, monthNumber: '11' },
    { name: 'December', days: 31, monthNumber: '12' }
  ];

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isMonthModalVisible, setIsMonthModalVisible] = useState(false);
  const [isYearModalVisible, setIsYearModalVisible] = useState(false);
  const monthString = months[currentMonthIndex];

  const monthYearModal = () => {
    isMonthModalVisible? (setIsMonthModalVisible(false) , setIsYearModalVisible(true)) : (setIsMonthModalVisible(true), setIsYearModalVisible(false))
   
  };

  const mainModal = () => {
    if (pressed) {
      pressed();
      //dateReset = true;
    }

    setIsModalVisible((prev) => !prev)
    setIsMonthModalVisible(false)
    setIsYearModalVisible(false)
  };

  const handleDayPress = (day:number) => {
    let maxChars = 31;
    if (currentMonth === 1) {
      maxChars = isLeapYear(currentYearValue) ? 29 : 28;
    } else if (currentMonth === 3 || currentMonth === 5 || currentMonth === 8 || currentMonth === 10) {
      maxChars = 30;
    }
    let paddedMonth = month;
    if (paddedMonth.length > 0){
      while (paddedMonth.length < 2) {
      paddedMonth = '0' + paddedMonth;
      }
    }
    setMonth(paddedMonth);

    setCanFocus(false)
    day < 10 ? setDay('0' + day.toString()) : setDay(day.toString())
    setYear(currentYear.toString())
    //setMonth((currentMonthIndex + 1).toString());
    setIsModalVisible((prev) => !prev)
    setIsMonthModalVisible(false)
    setIsYearModalVisible(false)
   };

  const toggleMonthModal = () => {
    setIsMonthModalVisible((prev) => !prev);
  };

  const toggleYearModal = () => {
    setIsYearModalVisible((prev) => !prev);
  };

  const handlePreviousMonth = () => {
    currentMonthIndex === 0 ? (currentYear > 1900 ? setCurrentYear(currentYear - 1): null) : null
    setCurrentMonthIndex((prevIndex) => (prevIndex === 0 ? 11 : prevIndex - 1));
  };

  const handleNextMonth = () => {
    currentMonthIndex === 11 ? (currentYear < 2099 ? setCurrentYear(currentYear + 1): null) : null
    setCurrentMonthIndex((prevIndex) => (prevIndex === 11 ? 0 : prevIndex + 1));
    };

  const renderMonth = () => {
    
    const firstDayOfMonth = new Date(currentYear, currentMonthIndex, 1).getDay();
  
    const days = Array.from({ length: monthString.days }, (_, dayIndex) => dayIndex + 1);
  
    const emptySlots = Array.from({ length: firstDayOfMonth }, (_, i) => i);
  
   
    return (
        <View style={styles.monthContainer}>
          <View style={styles.calendarGrid}>
            {emptySlots.map((slot) => (
              <TouchableOpacity key={`empty-${slot}`} style={styles.emptyDayButton} />
            ))}
            {days.map((dayCurrent) => (
              <TouchableOpacity
                key={`${monthString.name}-${dayCurrent}`}
                style={{...styles.dayButton,
                  backgroundColor: 
                  (('0' + dayCurrent.toString() === day) || (dayCurrent.toString() === day)) 
                  && monthString.monthNumber === month && currentYear.toString() === year 
                  ? darkColour : 'transparent'
                }}
                onPress={()=>{handleDayPress(dayCurrent)}}
              >
                <Text style={{...styles.dayText, color: 
                  (('0' + dayCurrent.toString() === day) || (dayCurrent.toString() === day)) 
                  && monthString.monthNumber === month && currentYear.toString() === year 
                  ? 'white' : darkColour}}>{dayCurrent}</Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      );
  };

  const renderMonthModalItem = (monthArray: Month, index: number) => {
    return (
      <TouchableOpacity
        key={`${monthArray.name}-${index}-${year}`}
        style={{...styles.modalItem, backgroundColor: currentMonthIndex === index ? darkColour : 'transparent'}}
        onPress={() => {
          setCanFocus(false)
          setMonth(monthArray.monthNumber)
          setCurrentMonthIndex(index);
          toggleMonthModal();
        }}
      >
        <Text style={{...styles.inputT, color: currentMonthIndex === index ? 'white' : darkColour}}>{monthArray.name}</Text>
      </TouchableOpacity>
    );
  };

  const renderYearModalItem = (year: number) => {
    return (
      <TouchableOpacity
        key={year}
        style={{...styles.modalYearItem, backgroundColor: currentYear === year ? darkColour : 'transparent' }}
        onPress={() => {
          setCanFocus(false)
          setYear(year.toString())
          setCurrentYear(year);
          setCurrentMonthIndex(0)
          setMonth('01')
          setDay('01')
          
          setIsYearModalVisible(false)
          setIsMonthModalVisible(true)
        }}
      >
        <Text style={{...styles.inputT, color: currentYear === year ? 'white' : darkColour}}>{year}</Text>
      </TouchableOpacity>
    );
  };

  const handleTextChangeDay = (value: string) => {
    const digitsOnly = value.replace(/[^0-9]/g, '');
    const trimmedValue = digitsOnly.slice(0, 2);
    let maxChars = 31;
    if (currentMonth === 1) {
      maxChars = isLeapYear(currentYearValue) ? 29 : 28;
    } else if (currentMonth === 3 || currentMonth === 5 || currentMonth === 8 || currentMonth === 10) {
      maxChars = 30;
    }

    if (parseInt(trimmedValue, 10) <= maxChars) {
      setDay(trimmedValue)
      if (trimmedValue === '00'){
      setDay('')
      }
    } else setDay('')


    if (inputRef2.current && trimmedValue.length > 1 && trimmedValue !== '00') {
      inputRef2.current.focus();
    }
    if (trimmedValue.length > 0) {
       setDayWidth(20)
    } else {
      setDayWidth(25)
    }
   
  };

  const handleFocusDay = () => {
    if (pressed) {
      pressed()
    }
    setColourDay('#DCE3E8')
    setColourDayText(darkColour)
  };

  const handleBlurDay=()=>{
    setColourDay('transparent')
    setColourDayText('white')

    let paddedDay = day;
    if (paddedDay.length > 0){
      while (paddedDay.length < 2) {
      paddedDay = '0' + paddedDay;
      }
    }
    setDay(paddedDay);
  }

  const handleTextChangeMonth = (value: string) => {
    const digitsOnly = value.replace(/[^0-9]/g, '');
    const trimmedValue = digitsOnly.slice(0, 2);
    (/^[2-9]{0,1}$/.test(trimmedValue)) && trimmedValue.length < 2 && trimmedValue ? setMonth('0' + trimmedValue) :
    parseInt(trimmedValue, 10) <= 12
    ? (
      setMonth(trimmedValue),
      trimmedValue.length > 1 && trimmedValue.charAt(0) === '0' && trimmedValue !== '00'
        ? (setCurrentMonthIndex(parseInt(trimmedValue.charAt(1), 10) - 1))
        : trimmedValue.length > 1 && parseInt(trimmedValue, 10) < 13 && trimmedValue !== '00'
        ? (setCurrentMonthIndex(parseInt(trimmedValue, 10) - 1))
        : setCurrentMonthIndex(new Date().getMonth()),
      trimmedValue === '00' ? setMonth('') : null
      )
      : setMonth('');
      
       (inputRef3.current && trimmedValue.length > 1 && trimmedValue !== '00') ?
        inputRef3.current.focus() : null
      
      if (trimmedValue.length > 0) {
        setMonthWidth(33)
      } else {
        setMonthWidth(33)
      }
  }



  const handleFocusMonth = () => {
    if (pressed) {
      pressed()
    }
    setColourMonthText(darkColour)
    setColourMonth('#DCE3E8')
  };

  const handleBlurMonth=()=>{
    setColourMonth('transparent')
    setColourMonthText('white')
   
    let maxChars = 31;
    if (currentMonth === 1) {
      maxChars = isLeapYear(currentYearValue) ? 29 : 28;
    } else if (currentMonth === 3 || currentMonth === 5 || currentMonth === 8 || currentMonth === 10) {
      maxChars = 30;
    }
    if (parseInt(day, 10) > maxChars){
      setDay(maxChars.toString())
    }

    let paddedMonth = month;
    if (paddedMonth.length > 0){
      while (paddedMonth.length < 2) {
      paddedMonth = '0' + paddedMonth;
      }
    }
    setMonth(paddedMonth);
    paddedMonth.length > 1 && paddedMonth.charAt(0) === '0' && paddedMonth !== '00' 
    ? setCurrentMonthIndex(parseInt(paddedMonth.charAt(1), 10) - 1)
    : paddedMonth.length > 1 && parseInt(paddedMonth, 10) < 13 && paddedMonth !== '00' 
    ? setCurrentMonthIndex(parseInt(paddedMonth, 10) - 1) 
    : setCurrentMonthIndex(new Date().getMonth())
  }

  const handleTextChangeYear = (value: string) => {
    let digitsOnly = value.replace(/[^0-9]/g, '');
    if (digitsOnly.length > 4){
      const trimmedValue = digitsOnly.substring(1,5)
      setYear(trimmedValue);
      setCurrentYear( /^(19|20)\d{2}$/.test(trimmedValue) ? parseInt(trimmedValue, 10) : new Date().getFullYear());
    } else {
      setYear(digitsOnly);
      setCurrentYear( /^(19|20)\d{2}$/.test(digitsOnly) ? parseInt(digitsOnly, 10) : new Date().getFullYear());
    }
  };

  const handleFocusYear = () => {
    if (pressed) {
      pressed()
    }
    setColourYear('#DCE3E8')
    setColourYearText(darkColour)
  };

  const handleBlurYear=()=>{
    setColourYear('transparent')
    setColourYearText('white')
    let paddedYear = year;
    if (paddedYear.length > 0){
      while (paddedYear.length < 4) {
      paddedYear = '0' + paddedYear;
      }
    }

    setYear(paddedYear);
    setCurrentYear( /^(19|20)\d{2}$/.test(paddedYear) ? parseInt(paddedYear, 10) : new Date().getFullYear());
    let maxChars = 31;
    if (currentMonth === 1) {
      maxChars = isLeapYear(currentYearValue) ? 29 : 28;
    } else if (currentMonth === 3 || currentMonth === 5 || currentMonth === 8 || currentMonth === 10) {
      maxChars = 30;
    }
    if (parseInt(day, 10) > maxChars){
      setDay(maxChars.toString())
      
    }
    setCanFocus(true)
    
  }

  const handleYearFlatlistLayout = () => {
    if (flatListRef.current) {
      flatListRef.current.scrollToIndex({
        index: scrollIndex > 46 ? 46 :
        scrollIndex - 2 < 0 
        ? scrollIndex: scrollIndex - 2,
        animated: true,
      });
    }
  }

    return(
    <View>
        <View style={{...styles.parent, borderColor: onError ?'#C40C0C' : darkColour}}>
        <View style={{alignSelf:'flex-end', height:'100%', flexDirection:'row'}}>
        <View style={{backgroundColor:'transparent', width:150, height:40, flexDirection:'row', marginTop:7, alignSelf:'center'}}>
        <View style={{maxWidth:40, height:20, backgroundColor:'transparent', borderRadius:0}}>
        <TouchableOpacity activeOpacity={0.8}
        onPress={() => {
          setCanFocus(true)
          setFocusNum(1)
        }}
        >
          <TextInput
          editable = {dateReset}
          style={{...styles.input, width:dayWidth, backgroundColor:colourDay, color: onError ? '#C40C0C' : colourDayText}}
          ref={inputRef1}
          value={day}
          onChangeText={handleTextChangeDay}
          onFocus={handleFocusDay}
          caretHidden
          placeholder="dd"
          placeholderTextColor={onError ? '#C40C0C' :'white'}
          clearButtonMode="never"
          selectTextOnFocus
          onBlur={handleBlurDay}
          selectionColor='#DCE3E8'
          focusable={canFocus}
        />
        </TouchableOpacity>
      </View>
      <View><Text style={{...styles.inputT, color: onError ? '#C40C0C' :'white'}}>/</Text></View>
      <View style={{maxWidth:40, height:20, backgroundColor:'transparent'}}>
      <TouchableOpacity activeOpacity={0.8}
        onPress={() => {
          setCanFocus(true)
          setFocusNum(2)
        }}
        >
          <TextInput
          editable = {dateReset}
          style={{...styles.input, textAlign: 'center', width:monthWidth, backgroundColor:colourMonth, color: onError ? '#C40C0C' : colourMonthText}}
          ref={inputRef2}
          value={month}
          maxLength={2}
          selectTextOnFocus
          placeholderTextColor={onError ? '#C40C0C' :'white'}
          clearButtonMode="never"
          placeholder="mm"
          onChangeText={handleTextChangeMonth}
          onFocus={handleFocusMonth}
          onBlur={handleBlurMonth}
          selectionColor='#DCE3E8'
          caretHidden
          focusable={canFocus}
        />
        </TouchableOpacity>
      </View>
      <View><Text style={{...styles.inputT, color: onError ? '#C40C0C' : 'white'}}>/</Text></View>
      <View style={{maxWidth:40, height:20, backgroundColor:'transparent'}}>
      <TouchableOpacity activeOpacity={0.8}
        onPress={() => {
          setCanFocus(true)
          setFocusNum(3)
        }}
        >
          <TextInput
          editable = {dateReset}
          style={{...styles.input, width:40, backgroundColor:colourYear, color: onError ? '#C40C0C' : colourYearText}}
          ref={inputRef3}
          value= {year}
          placeholder="yyyy"
          placeholderTextColor={onError ? '#C40C0C' :'white'}
          clearButtonMode="never"
          onChangeText={handleTextChangeYear}
          onFocus={handleFocusYear}
          onBlur={handleBlurYear}
          selectTextOnFocus
          selectionColor='#DCE3E8'
          caretHidden
          focusable={canFocus}
          
        />
        </TouchableOpacity>
      </View>
      </View>

            <TouchableOpacity 
            style={{alignSelf:'center', borderRadius:30, width:25, marginRight:5, height:25}}
            onPress={mainModal}
            disabled = {!dateReset}>
              
                <IconButton 
                icon={'calendar-range'} 
                iconColor= {onError ? '#C40C0C' : 'white' }
                size={20} 
                style={{width:35, 
                height:35, 
                padding:0, 
                marginTop:-4, 
                alignSelf:'center'}} 
                containerColor= {darkColour} 
                focusable
                />
                
            </TouchableOpacity>
        </View>
      </View>

      <PaperProvider>
      <Portal>
      <Modal visible={isModalVisible} onDismiss={mainModal} contentContainerStyle = {{width:370, height:410, borderWidth:2, borderRadius:10, backgroundColor:'white', borderColor:'#DCE3E8', marginTop: appearUp ? -490 : 410}}>
      <View style={{width:370, height:410, borderWidth:2, borderRadius:10, backgroundColor:'white', borderColor:'#DCE3E8'}}>
        <View style={{width:'100%', height:50}}>
        <View style={{flexDirection:'row'}}>
          <View style={{flex:7, marginTop:10, marginLeft:20 }}>
            <TouchableOpacity onPress={monthYearModal}>
            <Text style={{...styles.inputT}}>
             {isMonthModalVisible ? currentYear : `${monthString.name}, ${currentYear}`}
          </Text>
          </TouchableOpacity>
          </View>
          <View style={{flex:3, alignContent:'flex-end', flexDirection:'row', marginTop:10}}>
            <TouchableOpacity style={{alignSelf:'center', borderRadius:30, width:35, marginRight:5, height:55, marginHorizontal:6}} onPress={handlePreviousMonth}>
              <IconButton icon={'chevron-left'} iconColor= {darkColour} size={35} style={{width:35, height:35, padding:0, marginTop:-2, alignSelf:'center'}} containerColor= 'white' focusable/>
            </TouchableOpacity>
            <TouchableOpacity style={{alignSelf:'center', borderRadius:30, width:35, marginRight:20, height:55, marginHorizontal:6}} onPress={handleNextMonth}>
              <IconButton icon={'chevron-right'} iconColor= {darkColour} size={35} style={{width:35, height:35, padding:0, marginTop:-2, alignSelf:'center'}} containerColor= 'white' focusable/>
            </TouchableOpacity>
          </View>
        </View>
        </View>
        <View style={{flexDirection:'row', width:'100%', paddingHorizontal:21, marginBottom:10}}>
        <View style={{width:40, height:40, margin:3, paddingVertical:5}}>
          <Text style={{...styles.inputT,  color:darkColour, fontSize:17, alignSelf:'center'}}>S</Text>
        </View>
        <View style={{width:40, height:40, margin:3, paddingVertical:5}}>
          <Text style={{...styles.inputT,  color:darkColour, fontSize:17, alignSelf:'center'}}>M</Text>
        </View>
        <View style={{width:40, height:40, margin:3, paddingVertical:5}}>
          <Text style={{...styles.inputT,  color:darkColour, fontSize:17, alignSelf:'center'}}>T</Text>
        </View>
        <View style={{width:40, height:40, margin:3, paddingVertical:5}}>
          <Text style={{...styles.inputT,  color:darkColour, fontSize:17, alignSelf:'center'}}>W</Text>
        </View>
        <View style={{width:40, height:40, margin:3, paddingVertical:5}}>
          <Text style={{...styles.inputT,  color:darkColour, fontSize:17, alignSelf:'center'}}>T</Text>
        </View>
        <View style={{width:40, height:40, margin:3, paddingVertical:5}}>
          <Text style={{...styles.inputT,  color:darkColour, fontSize:17, alignSelf:'center'}}>F</Text>
        </View>
        <View style={{width:40, height:40, margin:3, paddingVertical:5}}>
          <Text style={{...styles.inputT,  color:darkColour, fontSize:17, alignSelf:'center'}}>S</Text>
        </View>
      </View>

      <View style={{width:'100%', height:276, paddingHorizontal:21}}>
        {renderMonth()}
      </View>
      </View>
      </Modal>
      </Portal>
      </PaperProvider>

      <PaperProvider>
      <Portal>
        <Modal visible={isMonthModalVisible} onDismiss={toggleMonthModal} contentContainerStyle = {{...styles.modalContainer, shadowColor: 'transparent', marginTop: appearUp ? -450 : 450 }}>
          <View>
            <FlatList
              data={months}
              keyExtractor={(item, index) => `${item.name}-${index}`}
              renderItem={({ item, index }) => renderMonthModalItem(item, index)}
              numColumns={3}
            />
          </View>
        </Modal>
        <Modal visible={isYearModalVisible} onDismiss={toggleYearModal} contentContainerStyle = {{...styles.modalContainer, marginLeft:8, shadowColor: 'transparent', marginTop: appearUp ? -450 : 450}}>
          <View style = {{...styles.modalContainer, width: 340}}>
            <FlatList
              ref={flatListRef}
              data={years}
              keyExtractor={(item) => item.toString()}
              renderItem={({ item }) => renderYearModalItem(item)}
              numColumns={4}
            initialNumToRender={years.length}
            onLayout={handleYearFlatlistLayout}
            />
          </View>
        </Modal>
      </Portal>
    </PaperProvider>
    </View>
  )

}

const styles = StyleSheet.create({
  container: {
    width: 322,
    height: 376,
    borderWidth:2,
    borderRadius:5,
    borderColor:'black'
  },
  parent: {
    width:200, 
    height:40, 
    backgroundColor:darkColour, 
    borderRadius:10, 
    borderLeftWidth:0,
    borderWidth:1
  },
  yearSelector: {
    flexDirection: 'row',
    marginBottom: 20
  },
  monthContainer: {
    marginBottom: 20
  },
  calendarGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start'
  },
  emptyDayButton: {
    width: 40,
    height: 40,
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 3,
    margin: 3
  },
  dayButton: {
    width: 40,
    height: 40,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 3,
    margin: 3,
    borderRadius:4
  },
  dayText: {
    fontFamily:'century gothic', 
    fontSize: 15,
    fontWeight: '400',
    color: darkColour
  },
  modalContainer: {
    marginLeft:21,
    width:321,
    height:325,
    backgroundColor: 'white'
  },
  modalItem: {
    margin:4,
    justifyContent: 'center',
    alignItems: 'center',
    height: 253/4,
    width: 297/3,
    borderRadius:10
  },
  modalYearItem: {
    borderRadius:10, 
    margin:4,
    justifyContent: 'center',
    alignItems: 'center',
    height: 253/4,
    width: 289/4,
  },
  modalItemText: {
    fontFamily:'century gothic', 
    fontSize: 17,
    fontWeight: '600',
    color: darkColour
  },
  input: {
    height: 25,
    width: 20,
    borderWidth: 0,
    paddingTop: 4,
    marginTop:3,
    borderRadius:0,
    fontFamily:'century gothic', 
    fontSize:17, 
    fontWeight:'normal', 
    textAlign:'left',
   
  },

  inputT: {
    padding: 0,
    fontFamily:'century gothic', 
    textAlign:'left',
    marginTop:5,
    color:darkColour, 
    fontSize:17, 
    fontWeight:'600'
      
  },

});






export default DatePicker;



